export default __webpack_public_path__ + "media/images/raty/like-4ac0e01b6732c88626c47bea8e88bae6.png";